import { diffLines } from './diff'
import styles from './studio.module.css'

type Props = { readonly before: string; readonly after: string; readonly labels: readonly [string, string] }

export function PromptDiff({ before, after, labels }: Props) {
  const lines = diffLines(before, after)
  const added = lines.filter((l) => l.kind === 'add').length
  const removed = lines.filter((l) => l.kind === 'del').length
  return (
    <div>
      <p className="muted" style={{ fontSize: 13 }}>
        {labels[0]} → {labels[1]}: добавлено строк {added}, удалено {removed}. Зелёным отмечено новое, красным убранное.
      </p>
      <pre className={styles.diff}>
        {lines.map((l, i) => (
          <div key={i} className={l.kind === 'add' ? styles.diffAdd : l.kind === 'del' ? styles.diffDel : undefined}>
            <span aria-hidden="true">{l.kind === 'add' ? '+ ' : l.kind === 'del' ? '− ' : '  '}</span>
            <span className="sr-only">{l.kind === 'add' ? 'добавлено: ' : l.kind === 'del' ? 'удалено: ' : ''}</span>
            {l.text || ' '}
          </div>
        ))}
      </pre>
    </div>
  )
}
